import React from 'react';
import './ErrorBoundary.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught an error:', error, info.componentStack);
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback !== undefined) {
        return this.props.fallback;
      }
      return (
        <div className="error-boundary">
          <p className="error-boundary__title">Etwas ist schiefgelaufen.</p>
          <p className="error-boundary__text">
            Dieser Bereich konnte nicht geladen werden. Bitte lade die Seite neu oder versuche es später erneut.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
